export default __webpack_public_path__ + "static/media/muteIcon.79ad45f5.svg";